<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="设备编号" v-model="devId"></el-input>
            </el-col>
            <el-col :span="4">
                <el-input placeholder="设备型号" v-model="termVersion"></el-input>
            </el-col>
            <el-col :span="14">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="devId" label="设备编号">
            </el-table-column>
            <el-table-column prop="termVersion" label="设备型号">
            </el-table-column>
            <el-table-column prop="termName" label="型号名称">
            </el-table-column>
            <el-table-column prop="location" label="货架位置">
            </el-table-column>
            <el-table-column prop="inStockDate" label="入库时间">
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        name: 'admin',
        data() {
            return {
                termVersion: '',
                devId:'',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if (this.termVersion.trim() != '') {
                    params.termVersion = this.termVersion;
                }
                if (this.devId.trim() != '') {
                    params.devId = this.devId;
                }
                this.$http.post('/manage/inStock/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            }
        },
        components: { Pagination }
    }
</script>